import { IColorTag } from '../../../../../../../types/types';
import { EColorTagColor } from '../../../../../../../types/model';
import { ONE_HOUR } from '../../../../../main/kanbanView/components/CardAgingIndicator/constants';

export const PREVIEW_CARD_NAME = 'Ocean wave';
export const PREVIEW_CARD_DONE_PERCENT = 33;
export const PREVIEW_CARD_ATTACHMENTS_COUNT = 5;
export const PREVIEW_CARD_SUBCARDS_COUNT = 3;
export const PREVIEW_CARD_CHECKLIST_ITEMS_COUNT = 3;
export const PREVIEW_CARD_DONE_CHECKLIST_ITEMS_COUNT = 1;
export const PREVIEW_CARD_START_DATE = '15 Apr';
export const PREVIEW_CARD_DUE_DATE = '28 Nov';
export const PREVIEW_CARD_ESTIMATE = '5d 9h 3m';
export const PREVIEW_CARD_LAST_ACTIVITY = ONE_HOUR;
export const PREVIEW_CARD_CHECKLIST_COMMENTS_COUNT = 24;
export const PREVIEW_CARD_NUMBER = 'MFB-4';
export const PREVIEW_CARD_TAGS = ['animation', 'onboarding', 'experimental'];
export const PREVIEW_CARD_COLOR_TAGS: IColorTag[] = [
    {
        name: 'Design',
        color: EColorTagColor.PASTEL_PURPLE,
    },
    {
        name: 'UX',
        color: EColorTagColor.PASTEL_BLUE,
    },
    {
        name: 'Marketing',
        color: EColorTagColor.PASTEL_GREEN,
    }
];
